/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { FaRupeeSign } from 'react-icons/fa'
import { format } from 'date-fns'
import { CardActionCell } from '../table/cells'
import DefaultFarmIcon from '../../../assets/images/default-farm.svg'
import './CardTable.scss'

interface FarmCardProps extends React.ComponentProps<typeof Panel> {
  title?: string;
  imageUrl: string;
  subtitle?: string;
  date?: string;
  farmArea?: string;
  farmAreaUnit?: string;
  noOfAnimals?: string;
  totalIncome?: number;
  totalExpense?: number;
  data?: any;
  onAction?: (eventKey?: string, rowData?: any) => void;
  actionOptions?: any;
}

const FarmCard: React.FC<FarmCardProps> = ({
  title = 'Farm Card title',
  imageUrl,
  subtitle,
  date,
  totalIncome,
  totalExpense,
  data,
  farmArea,
  farmAreaUnit,
  noOfAnimals,
  onAction,
  actionOptions,
  handleSelection
}) => {
  const [imgSrc, setImgSrc] = useState(imageUrl)
  const handleImageError = () => {
    setImgSrc(DefaultFarmIcon)
  }
  let borderClass = ''

  if (totalIncome !== undefined && totalExpense !== undefined) {
    if (totalExpense > totalIncome) {
      borderClass = 'high-expense'
    } else {
      borderClass = 'low-expense'
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className={`card ${borderClass}`}
      onClick={() => handleSelection?.(data)}
    >
      <div className="card-header">
        <img src={imgSrc} alt={subtitle} onError={handleImageError} />
      </div>
      <div className="farm-card-header">
        <h3>{title}</h3>
      </div>
      <div className="farm-card-body">
        {subtitle && <div>{subtitle}</div>}
        {noOfAnimals && (
          <div>
            <b>Animals:</b> {noOfAnimals}
          </div>
        )}
        {farmArea && (
          <div>
            <b>Area:</b> {farmArea} {farmAreaUnit}
          </div>
        )}
        {date && (
          <div>
            <b>Created:</b> {format(new Date(date), 'dd MMM yyyy')}
          </div>
        )}
        <div className="income-expense">
          <div>
            <b>
              Total Income <br />
            </b>
            <span className="income">
              <FaRupeeSign />
              {totalIncome}
            </span>
          </div>
          <div>
            <b>
              Total Expense <br />
            </b>
            <span className="expense">
              <FaRupeeSign />
              {totalExpense}
            </span>
          </div>
        </div>
      </div>
      {actionOptions && (
        <div className="farm-card-action" onClick={(e) => e.stopPropagation()}>
          <CardActionCell
            rowData={data}
            dataKey="action"
            onAction={onAction}
            actionOptions={actionOptions}
          />
        </div>
      )}
    </div>
  )
}

export default FarmCard
